import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MensagensService } from 'app/services/mensagens.service';
import { SiteService } from 'app/services/site.service';
import { ValidadorService } from 'app/services/validador.service';
import { AcessoRestritoSiteService } from 'app/services/acesso-restrito.service';
import { DownloadService } from 'app/services/download.service';
import { NgbActiveModal, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-pesquisa-satisfacao',
  templateUrl: './modal-pesquisa-satisfacao.component.html',
  styleUrls: ['./modal-pesquisa-satisfacao.component.css']
})
export class ModalPesquisaSatisfacaoComponent implements OnInit {

  erromessage = '';
  @Input() public dados: any;
  erroresposta = '';
  inSpinner = false;

  constructor(
    private formBuilder: FormBuilder,
    public validadorService: ValidadorService,
    public downloadService: DownloadService,
    public acessoRestritoSiteService: AcessoRestritoSiteService,
    public servico: SiteService,
    public router: Router,
    public activeModal: NgbActiveModal,
    public mensagensService: MensagensService
  ) {
  }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.close(null);
  }

  responder() {
    this.activeModal.close(null);
    this.router.navigate([`pesquisa-satisfacao-v2/${this.dados.idPesquisa}`]);
  }

}
